import type { ILocation } from "@/interfaces/api/location.interface"
import { BaseRepository } from "@/repositories/base-repository"

export class LocationRepository extends BaseRepository<ILocation> {
  protected resourcePath = "core/locations"
}
